import { Col, DatePicker, Form, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import {
  EXISTING_PO_MAP_LIST,
  GET_DIGITALIZATION_STYLES,
  PO_MAP_NEW_ENDPOINT,
  SEWING_LINES,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";
import SubStyleFilterCol from "./SubStyleFilterCol";

const FinishingHourlyIronFilter = ({ initialTableData, filterClearTrigger = 0 }) => {
  // States
  const [sewingList, setSewingList] = useState([]);
  const [buyersList, setBuyersList] = useState([]);
  const [stylesList, setStylesList] = useState([]);
  const [poList, setPOList] = useState([]);
  const [finishingLineList, setFinishingLineList] = useState([]);

  // Antd
  const { Option } = Select;

  const getSewingList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(SEWING_LINES, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSewingList(response?.data?.data?.data || []);
    }
  };

  const getBuyersList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(
      "/api/digitalization/buyers",
      false,
      bodyData,
    );

    if (response && response?.data?.code === 200) {
      const buyers =
        response?.data?.data?.data?.map((buyer) => ({
          id: buyer.id,
          name: buyer.name,
        })) || [];
      setBuyersList(buyers);
    }
  };

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(GET_DIGITALIZATION_STYLES, false, bodyData);

    if (response && response?.data?.code === 200) {
      const styles =
        response?.data?.data?.data?.map((style) => ({
          id: style.id,
          name: style.style_no,
        })) || [];
      setStylesList(styles);
    }
  };

  const getPOList = async (value = null) => {
    const bodyData = {
      ...(value && { original_po: value }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(PO_MAP_NEW_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setPOList(data);
    }
  };

  const fetchFinishingLines = useCallback(async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };

    const query = `/api/digitalization/finishing-lines`;

    try {
      const response = await getData(query, false, bodyData);
      console.log("🚀 ~ fetchFinishingLines ~ response:", response);
      if (response?.status === 200) {
        const dropdownData = response?.data?.data?.data?.map((item) => ({
          name: item.name,
          id: item.id,
        }));
        setFinishingLineList(dropdownData);
      }
    } catch (error) { }
  }, []);

  // Effects

  // Effects
  useEffect(() => {
    getSewingList();
    getBuyersList();
    getStyleList();
    getPOList();
    fetchFinishingLines();
  }, [fetchFinishingLines]);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Entry Date" name="entry_date">
          <CustomDatePicker
            style={{ width: "100%" }}
            size="small"
            placeholder="Select Entry Date"
          />
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Style" name="style_id">
          <Select
            showSearch
            placeholder="Select Style"
            filterOption={false}
            size="small"
            onSearch={(value) => {
              getStyleList({ style_no: value });
            }}
          >
            {isArrayAndHasValue(stylesList) &&
              stylesList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <SubStyleFilterCol filterClearTrigger={filterClearTrigger} />

      <Col span={4}>
        <Form.Item label="Original PO" name="po_map_id">
          <Select
            showSearch
            placeholder="Select an original PO"
            onSearch={(value) => {
              getPOList(value);
            }}
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => getPOList()}
          >
            {isArrayAndHasValue(poList) &&
              poList.map((po) => (
                <Option value={po.id} key={po.id}>
                  {po.original_po}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Finishing Line" name="finishing_line_id">
          <Select
            showSearch
            placeholder="Select a Finishing Line"
            onSearch={(value) => {
              fetchFinishingLines({ name: value });
            }}
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => fetchFinishingLines()}
          >
            {isArrayAndHasValue(finishingLineList) &&
              finishingLineList.map((line) => (
                <Option value={line.id} key={line.id}>
                  {line.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default FinishingHourlyIronFilter;
